import { render } from "./AboutTrad.vue?vue&type=template&id=f7b9a084"
import script from "./AboutTrad.vue?vue&type=script&lang=js"
export * from "./AboutTrad.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__